// extracted by mini-css-extract-plugin
export default {"card":"I2-z"};